import { RESET_STATE } from 'store/global/actions';

import { CHANNEL_PROGRAMS_ACTION_TYPE } from '../actions';

const initialState = null;

const channelProgramsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANNEL_PROGRAMS_ACTION_TYPE.GET_CHANNEL_PROGRAMS:
      return payload;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default channelProgramsReducer;
